'use strict';

const breakpoints = require('./cssVars').breakpoints.integer;



/**
 * Expose the queries used here so they can be used elsewhere.
 * @type {Object}
 */
// jscs:disable
// TODO: Disabling jscs because it incorrectly flags these commas as not sticking to the previous expression. Upgrade
// JSCS to re-enable it here. Version 1.6.2 when this note was written.
const queries = {
    xs: `(max-width: ${breakpoints['mobile-portrait'] - 1}px)`,
    sm: `(min-width: ${breakpoints['mobile-portrait']}px) and ` +
        `(max-width: ${breakpoints['mobile-large-landscape'] - 1}px)`,
    md: `(min-width: ${breakpoints['mobile-large-landscape']}px) and ` +
        `(max-width: ${breakpoints['tablet-portrait'] - 1}px)`,
    lg: `(min-width: ${breakpoints['tablet-portrait']}px) and ` +
        `(max-width: ${breakpoints.desktop - 1}px)`,
    xl: `(min-width: ${breakpoints.desktop}px)`
};
// jscs:enable

/**
 * Check if this is a mobile device.
 * @return {Boolean}
 */
function isMobile() {
    return window.matchMedia(queries.xs + ', ' + queries.sm + ', ' + queries.md).matches;
}

/**
 * Check if the the device is a tablet.
 * @return {Boolean}
 */
function isTablet() {
    return window.matchMedia(queries.lg).matches;
}

/**
 * Check if the the device is mobile or a tablet.
 * @return {Boolean}
 */
function isMobileOrTablet() {
    return window.matchMedia(queries.xs + ', ' + queries.sm + ', ' + queries.md + ', ' + queries.lg).matches;
}

/**
 * Check if this is a desktop device.
 * @return {Boolean}
 */
function isDesktop() {
    return window.matchMedia(queries.xl).matches;
}

/**
 * Check if the the device is a tablet or desktop.
 * @return {Boolean}
 */
function isTabletOrDesktop() {
    return window.matchMedia(queries.lg + ', ' + queries.xl).matches;
}

module.exports = {
    queries,
    isMobile,
    isTablet,
    isMobileOrTablet,
    isDesktop,
    isTabletOrDesktop
};



// WEBPACK FOOTER //
// ./assets/js/global/core/commonjs/screenSize.es.js